import { forwardRef, ReactNode } from 'react'
import { lightImpactVibrate } from '../../utils/appBridge'

type ButtonPropTypes = {
  onClick: (e?: React.MouseEvent) => void
  buttonClassName?: string
  labelClassName?: string
  iconClassName?: string
  icon?: any
  label?: string
  isFullWidth?: boolean
  children?: ReactNode
  disabled?: boolean
  'aria-label'?: string
  'aria-description'?: string
}

const Button = forwardRef<HTMLButtonElement, ButtonPropTypes>(function Button(
  {
    onClick,
    label,
    icon,
    isFullWidth,
    buttonClassName,
    labelClassName,
    iconClassName,
    children,
    disabled,
    'aria-label': ariaLabel,
    'aria-description': ariaDescription
  },
  ref
) {
  return (
    <button
      ref={ref}
      type='button'
      aria-label={ariaLabel}
      aria-description={ariaDescription}
      disabled={disabled}
      onClick={(e) => {
        lightImpactVibrate()
        onClick(e)
      }}
      className={`flex items-center justify-center gap-[4px] h-[32px] ${isFullWidth ? 'w-full' : 'w-max'} bg-[#EBF2F2] 
      rounded-[12px] font-[500] text-[12px] text-[#232323] py-0 border-none ${buttonClassName ?? ''} ${disabled ? 'bg-grey60 cursor-not-allowed' : ''}`}
    >
      {icon && <div className={`${iconClassName ?? ''}`}>{icon}</div>}
      {label && <div className={`${labelClassName ?? ''}`}>{label}</div>}
      {children && <>{children}</>}
    </button>
  )
})

export default Button
